import React from 'react';
import {Row, Col, Card} from 'react-materialize';


import {FormattedMessage, FormattedHTMLMessage} from 'react-intl';

const Sobre = () => (

    <Card>

        <Row>
            <div align="center">
                <h5><p><b><FormattedMessage id={"hierarchy_protection_title"} defaultMessage={"Como proteger o local de trabalho e os trabalhadores usando a hierarquia de controles?"}/></b></p></h5>
            </div>
            <div align="justify" style={{padding:"50px"}}>
                <ol>
                    <li><FormattedMessage id={"hierarchy_protection_text_1"} defaultMessage={"Os controles de eliminação e substituição de riscos incluem quarentena e isolamento, o que significa um trabalhador por vez."}/></li>
                    <li><FormattedMessage id={"hierarchy_protection_text_2"} defaultMessage={"Os controles de engenharia incluem instalar barreiras físicas entre os trabalhadores, principalmente se eles trabalharem lado a lado. Nesse contexto, os trabalhadores devem ficar 2m (6 pés) longe um do outro."}/></li>
                    <li><FormattedMessage id={"hierarchy_protection_text_3"} defaultMessage={"Os controles administrativos incluem:"}/></li>
                        <ul>
                            <li>• <FormattedMessage id={"hierarchy_protection_text_4"} defaultMessage={"Treinamento para trabalhadores sobre o uso de equipamentos de proteção individual (EPI) e outras medidas de segurança."}/></li>
                            <li>• <FormattedMessage id={"hierarchy_protection_text_5"} defaultMessage={"Controlar a temperatura dos trabalhadores."}/></li>
                        </ul>
                    <li><FormattedMessage id={"hierarchy_protection_text_6"} defaultMessage={"Equipamento de Proteção Individual (EPI):"}/></li>
                        <ul>
                            <li>• <FormattedMessage id={"hierarchy_protection_text_7"} defaultMessage={"Usar máscaras em todas as atividades (fornecidas pelo empregador)."}/></li>
                            <li>• <FormattedMessage id={"hierarchy_protection_text_8"} defaultMessage={"Use proteção facial, sobre a máscara, nas atividades de pesca e colheita e nas que envolvem salpicos de água."}/></li>
                        </ul>
                </ol>
            </div>
            <div align="center">
                <a href={"/protection"} style={{background:'white', color: 'black'}}>
                    <button style={{backgroundColor:"#7F7FFF", border:"white", borderRadius:"15px"}}>
                        <h5><FormattedMessage id={"back"} defaultMessage={"VOLTAR"}/></h5>
                    </button>
                </a>
            </div>
        </Row>

        

    </Card>

);

export default Sobre;